import React from 'react';
import { Image, View } from 'react-native';
import {
  chat_Bottom, chat_Top,
} from '../../../../utils/ImagesManagementUtils';
import { Android } from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================

const ChatBubbles = ({
  backgroundColor, ToptintColor, BottomtintColor, simPlatform, multi = 1,
}) => {
  // fix backgroundColor
  const myStyles = {
    ViewStyle: {
      // backgroundColor,
    },
    chatTopStyle:
      {
        width: 105 * multi,
        height: 25 * multi,
        tintColor: ToptintColor,
      },
    chatBottomStyle:
      {
        width: 135 * multi,
        height: 25 * multi,
        marginLeft: 35 * (multi ** 0.5),
        marginTop: simPlatform === Android ? 10 * multi : 20 * multi,
        tintColor: BottomtintColor,
      },
  };

  return (
    <View style={myStyles.ViewStyle}>
      <Image
        fadeDuration={0}
        style={myStyles.chatTopStyle}
        source={chat_Top}
      />
      <Image
        fadeDuration={0}
        style={myStyles.chatBottomStyle}
        source={chat_Bottom}
      />
    </View>
  );
};
export default ChatBubbles;
